import { render, staticRenderFns } from "./resultGroup.vue?vue&type=template&id=7b78522c"
import script from "./resultGroup.vue?vue&type=script&lang=js"
export * from "./resultGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ResultItem: require('/vercel/path0/components/resultItem.vue').default,Slider: require('/vercel/path0/components/ui/slider.vue').default})
